const betBuilders = {
    title: 'Example JSON',
    expectedOutput: '412499.99999999994',
    initialDisplayedCode: `{
	"betBuilders": [{
		"selectedOdds": {
			"decimal": 1100,
			"american": "-1000",
			"fractional": "1/10"
		},
		"selectedOutcomeIds": [100]
	}],`,
    moreCode: `
	"betOffers": [{
		"id": 300,
		"eachWay": {
			"fractionMilli": 1200
		}
	}],
	"hasSelectedTeaser": false,
	"selectedOutcomes": [{
		"id": 100,
		"odds": 1100,
		"nrOfPermutations": 2,
		"betOfferId": 300
	},
	{
		"id": 101,
		"odds": 1200,
		"nrOfPermutations": 1,
		"betOfferId": 300
	}],
	"selectedReward": {},
	"selectedTab": "combination",
	"stakes": [{
		"stake": 1,
		"outcomeId": 100,
		"toWinInput": 100,
		"eachWaySelected": false,
		"type": "combination"
	}]
}`,
};

export default betBuilders;
